
import { RangerEntityDecoratorBase } from './ranger.decorator.base';


export class RangerEntityDecorator extends RangerEntityDecoratorBase {
  constructor() {
    super();
  }
}



